// extracted by mini-css-extract-plugin
export default {"container":"Monitor1_container__2qcoG","rows":"Monitor1_rows__3cULe"};